module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__large"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Tidslinje\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Her er der noget content\n                ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8ec0a38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/pages/timeline.vue
// module id = 363
// module chunks = 1